import React, { useCallback, memo } from 'react';

import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  id?: string;
  className?: string;
  /** modal, nonModal : 기본 center 고정, style을 이용해서 위치수정  */
  type?: 'drawer' | 'modal' | 'nonModal' | undefined;
  /** drawer 타입에서 사용되어지고 기본 transition 효과 적용   */
  placement?: 'left' | 'right' | 'bottom' | 'top' | undefined;
  style?: React.CSSProperties;
  label?: string;
  isOpen?: boolean;
  dimClosable?: boolean;
  children?: React.ReactNode;
  onClose?: () => void;
}

// wconcept-ui-renewal
function Modal({
  id,
  className,
  type = 'drawer',
  placement = 'bottom',
  style,
  label,
  isOpen = false,
  dimClosable = true,
  children,
  onClose,
}: IProps): React.JSX.Element {
  // EVENT HANDLER : onClose(취소)
  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  // EVENT HANDLER : dim(취소)
  const onClickCloseDim = useCallback(
    (
      e:
        | React.TouchEvent<HTMLElement>
        | React.MouseEvent<HTMLElement, MouseEvent>
    ) => {
      const { pageX } = e as React.MouseEvent<HTMLElement, MouseEvent>;
      /* const _e =
      (e as React.TouchEvent<HTMLElement>).touches ||
      (e as React.TouchEvent<HTMLElement>).changedTouches ||
      (e as React.MouseEvent<HTMLElement, MouseEvent>).pageX; */

      e.stopPropagation();
      if (e.target === e.currentTarget && pageX < e.currentTarget.clientWidth)
        handleClose();
    },
    [handleClose]
  );

  return (
    <S.Modal
      id={id || undefined}
      role="dialog"
      aria-label={label}
      aria-modal={isOpen}
      tabIndex={-1}
      type={type}
      $placement={type === 'drawer' ? placement : undefined}
      style={style}
      className={classNameBind([
        'modal-wrap',
        isOpen ? 'active' : '',
        type ? `type-${type}` : '',
        className || '',
      ])}
    >
      <S.Layout
        className="modal-overlay"
        onMouseDown={dimClosable ? onClickCloseDim : null}
      >
        <S.Box className="modal-content" tabIndex={0}>
          {children}
        </S.Box>
      </S.Layout>
    </S.Modal>
  );
}

export default memo(Modal);
